import { render, staticRenderFns } from "./Alquimia.vue?vue&type=template&id=bc500220&scoped=true&"
import script from "./Alquimia.vue?vue&type=script&lang=js&"
export * from "./Alquimia.vue?vue&type=script&lang=js&"
import style0 from "./Alquimia.vue?vue&type=style&index=0&id=bc500220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc500220",
  null
  
)

export default component.exports